$(document).ready(function() {

  const $mobileMenu = $('.mobile-megamenu');
  const scrollClass = 'scrolled';
  const scrollPoint = 90;
  let removeTimer; // to clear timeout

  $(window).on('scroll', function() {
    clearTimeout(removeTimer); // clear any pending removal

    if ($(this).scrollTop() > scrollPoint) {
      $mobileMenu.addClass(scrollClass);
    } else {
      // delay removing the class slightly
      removeTimer = setTimeout(function() {
        $mobileMenu.removeClass(scrollClass);
      }, 600);
    }
  });

  $(document).on('click', '.mobile-menu-icon', function() {
       $('.mobile-megamenu').toggleClass('open-menu');
       $('.mobile-menu-icon').toggleClass('active-menu-icon');
       setTimeout(function(){
         $('.mobile-header-sidebar').toggleClass('open-wrappers');
        }, 330);
      //  $('body').toggleClass('opened-drawers');
       $('html').toggleClass('opened-drawers');
       $('.overlay-content').toggleClass('open-overlay');
       $('.header').toggleClass('active-main-menu');
   });

   $(document).on('click', '.close-button', function() {
       setTimeout(function(){
         $('.mobile-megamenu').removeClass('open-menu');
       }, 40);
       $('.mobile-header-sidebar').removeClass('open-wrappers');
       setTimeout(function(){
        //  $('body').removeClass('opened-drawers');
         $('html').removeClass('opened-drawers');
         $('.overlay-content').removeClass('open-overlay');
        $('.header').removeClass('active-main-menu');
        $('.mobile-menu-icon').removeClass('active-menu-icon');
        }, 400);

    $('.mobile-megamenu-product').removeClass('show');
      $('.drawer-main').removeClass('main-submenu-open');
       $('.mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
      $('.sublink-dropdown').removeClass('show');
    });

    $(document).mouseup(function (e) {
       var container = $('.mobile-megamenu');
       if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-megamenu').hasClass('open-menu')) {
       $('.mobile-megamenu').removeClass('open-menu')
       $('.overlay-content').removeClass('open-overlay')
      //  $('body').removeClass('opened-drawer');
       $('html').removeClass('opened-drawers');
      $('.header').removeClass('active-main-menu');
      $('.mobile-menu-icon').removeClass('active-menu-icon');
       }
   });

    $(document).on('click','.back-section',function(event) {
      event.preventDefault();
      $('.dropdown-menus').removeClass('show');
      $('.drawer-main').removeClass('main-submenu-open');
       $('.sub-mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
     });

    $(document).on('click', '.drawer-main .accordion', function(event) {
        event.preventDefault();

        $('.mobile-header-menu-nav').addClass('submenu-open');
        $('.drawer-main').addClass('main-submenu-open');
        var $submenu = $(this).next();
        
        if ($submenu.hasClass('show')) {
            $submenu.removeClass('show');
            $submenu.find('.sub-mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
        } else {
            $(this).parent().parent().find('.drawer-main .mobile-megamenu-product').removeClass('show');
            $submenu.addClass('show');
            setTimeout(function(){
               $submenu.find('.sub-mobile-submenu-wrapper').addClass('open-submenu-wrapper');
            }, 330);
        }
    });

    $(document).on('click','.drawer-main .accordion-menu',function(event) {
      event.preventDefault();
      $('.child-accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).removeClass('open-dropdwan');
        $(this).find('.child-accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-grandchild').removeClass('show');
        $(this).parent().parent().find('li .dropdown-grandchild').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).addClass('open-dropdwan');
        $(this).find('.child-accordion-plus-icon').addClass('is-open');
      }
    });

});
